import { render, staticRenderFns } from "./SetmentList.vue?vue&type=template&id=9a56c830&scoped=true&"
import script from "./SetmentList.vue?vue&type=script&lang=js&"
export * from "./SetmentList.vue?vue&type=script&lang=js&"
import style0 from "./SetmentList.vue?vue&type=style&index=0&id=9a56c830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a56c830",
  null
  
)

export default component.exports